// Error Boundary to catch and display React errors
import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
  errorInfo: ErrorInfo | null;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null,
    errorInfo: null
  };

  public static getDerivedStateFromError(error: Error): State {
    return {
      hasError: true,
      error,
      errorInfo: null
    };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({
      error,
      errorInfo
    });
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div style={{ 
          padding: '20px', 
          backgroundColor: '#ff6b6b', 
          color: 'white', 
          margin: '20px',
          borderRadius: '8px',
          fontFamily: 'monospace'
        }}>
          <h2>❌ Something went wrong!</h2>
          <details style={{ whiteSpace: 'pre-wrap', marginTop: '10px' }}>
            <summary>Error Details (click to expand)</summary>
            <div style={{ marginTop: '10px', backgroundColor: 'rgba(0,0,0,0.2)', padding: '10px', borderRadius: '4px' }}>
              <strong>Error:</strong> {this.state.error?.message}
              <br />
              <strong>Stack:</strong>
              <pre style={{ fontSize: '12px', marginTop: '10px' }}>
                {this.state.error?.stack}
              </pre>
              <strong>Component Stack:</strong>
              <pre style={{ fontSize: '12px', marginTop: '10px' }}>
                {this.state.errorInfo?.componentStack}
              </pre>
            </div>
          </details>
          <button 
            onClick={() => window.location.reload()} 
            style={{ 
              marginTop: '15px', 
              padding: '10px 20px', 
              backgroundColor: 'white', 
              color: '#ff6b6b', 
              border: 'none', 
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Reload Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
